export const ADD_SUCCESS = 'Новая группа юзеров добавлена';
export const ADD_ERROR = 'Не удалось добавить новую группу юзеров';
